import { withProspectsAccess } from "@crm-src/components/page-permission-guard"

import { ProspectsListPage } from "./ProspectsPage"

/**
 * /crm/ai-prospects — prospects created by the autonomous XOP sales agent
 * (Sales ▸ Leads → Convert to Prospect). Reuses the SAME list component as the
 * regular Prospects page, fixed to the "ai" origin (pins `ai_generated=true`).
 * Manage-only: no Add / Import (humans don't hand-create AI prospects). Shares
 * the `prospects` page permission with the regular page.
 */
function AiProspectsPage() {
  return <ProspectsListPage origin="ai" />
}

export default withProspectsAccess(AiProspectsPage)
